<template lang="html">

  <section class="encabezado row-center" :style="`background:url(${background}) center/cover no-repeat`">

    <h1 :style="style.colorWhite">{{$t(`encabezado.${data}`)}}</h1>

    <div class="migas-wrapper" :style="ownstyles.migas_wrapper" v-if="showMigas">
      <div class="container">
        <migas :inicioPersonalizado="inicioPersonalizado"></migas>
      </div>
    </div>

  </section>

</template>

<script lang="js">

  import migas from '@/components/parts/migas';

  import {mapGetters} from 'vuex';

  export default  {
    name: 'encabezado',
    props: ['data','inicioPersonalizado'],
    components : {
      'migas' : migas
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        background : 'getBackground',
        style : 'getStyles'
      }),
      ownstyles : function() {
        return {
          migas_wrapper : {
            background : this.colors.basic
          }
        }
      },
      showMigas : function(){
        let forbidden = ['/'];
        return !(forbidden.some(el => el == this.$route.path));
      }
    }
  }
</script>

<style scoped lang="scss">

@import '@/assets/css/colors.scss';

.encabezado{
  background: url(/static/img/background.jpg) center/cover no-repeat;
  height: 25vh;
  min-height: 250px;
  padding: 50px 20px;
  position: relative;
  z-index: 11;
}


.encabezado h1{
  font-size: 36px;
  font-weight: 700;
}

.migas-wrapper{
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  display: inline-block;
  padding: 10px 0;
}

@media screen and (max-width: 1023px){

  .encabezado{
    min-height: 150px;
    height: 25vh;
  }

  .encabezado h1{
    font-size: 24px;
  }

  .migas-wrapper{
    display: none;
  }
}

@media screen and (max-width: 450px){

  .encabezado{
    min-height: 150px;
    height: 20vh;
  }

  .encabezado h1{
    font-size: 20px;
  }
}




</style>



// WEBPACK FOOTER //
// src/components/parts/encabezado.vue